export default __webpack_public_path__ + "static/media/thumb-up.97a1edba.svg";